import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'; // Replaced Ant Design icons
// Removed Modal, Spin, Menu, Progress imports from 'antd'
import { API } from 'aws-amplify'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import zoomImage from '../../../images/zoom.png'
import { useGlobalState } from '../../../store'
import { useLocalization } from '../../../localization'; // Added localization hook
// Added CB component imports
import { CBAlert, CBModal, CBButton } from '../../core/components/cbd'; // Added CBButton, CBModal
import { CBDropdown, CBMenu, CBMenuItem } from '../../core/components/CBDropdown';
import { CBSpin } from '../../core/components/CBSpin';
import { CBAvatar } from '../../core/components/CBAvatar';
import { CBProgress } from '../../core/components/CBProgress'; // Added CBProgress
import {
  CBHeader,
  CBList, // Assuming CBList is in cbd
  CBListItem,
  CBCheckItem // Added for AccountItem usage
} from '../../core/components/cbd'
import ScheduleItem from './ScheduleItem' // Assuming refactored
import VanityUrl from './VanityUrl' // Assuming refactored

import { ReactComponent as Info } from '../../../images/svg/info.svg'

// Removed duplicate Loading3QuartersOutlined import
import { ReactComponent as Scheduling } from '../../../images/svg/logo-booking.svg'
import { ReactComponent as Add } from '../../../images/svg/plus.svg'
import { ReactComponent as Close } from '../../../images/svg/x-close.svg'
import { accountIconMap } from '../../../utils/customIcons' // Import needed for Avatar replacement
import { ReactComponent as GoogleLogo } from '../../../images/svg/google-logo.svg'; // Import needed for Avatar replacement
import { ReactComponent as More } from '../../../images/svg/menu-more-horizontal.svg'; // Import needed for Dropdown replacement
import moment from 'moment'; // Import moment used in AccountItem logic
import momentTz from 'moment-timezone'; // Import momentTz used in AccountItem logic
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Keep FontAwesome


// --- AccountItem Component Definition (Moved from original position if it was separate) ---
const googleColors = [
  '#EF972C', '#16E6B7', '#6F5D70', '#A2E5F4', '#C8C9CA',
  '#3A677D', '#717234', '#FF484F', '#F1F104', '#a4bdfc',
];

const CopyElement = ({text="hi"}) => {
  const [copied,setCopied] = useState(false)
  return <a className="text-sm cursor-pointer hover:underline text-blue-600" onClick={ // Added styling
    e=>{
      navigator.clipboard.writeText(text.toString())
      setCopied(true)
      setTimeout(() => setCopied(false), 1500); // Reset after a delay
    }
  }>{copied ? t('scheduler.selectList.accountItem.copied') : t('scheduler.selectList.accountItem.copy')}</a>
}

const AccountItem = ({ item, setShowError }) => {
  const { t } = useLocalization(); // Initialize localization hook for AccountItem
  const [showCalendars, setShowCalendars] = useState(false)
  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Handler for delete confirmation
  const handleDeleteConfirm = async () => {
    setShowDeleteModal(false); // Close modal
    deleteAccount(); // Call existing delete logic
  };

  // Function to show modal
  function showDeleteConfirm() {
    setShowDeleteModal(true);
  }

  const deleteAccount = () => {
    API.del('account', '/account?id=' + item.calendarAccountId, { body: {} })
      .then(async () => {
        window.location.href = window.location.origin + '/dashboard/accounts/';
        window.dataLayer?.push({ event: 'dashboardEvent', category: 'userActivity', action: 'deleteAccount', label: item.ownerId, email: item.email });
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.message || 'An error occurred deleting the account.';
        setShowError(errorMsg); // Use callback to show error in parent
      });
  }

  const redirectToService = async (redirectUri) => { window.location.href = redirectUri; }

  const reauth = () => {
    API.del('account', '/account?unhook=true&id=' + item.calendarAccountId, { body: {} })
      .then(async () => {
        if (item.calendarAccountType == 'ms') {
          const clientId = item.msType === 'gcc' ? process.env.REACT_APP_OAUTH_O365_CLIENT_GCC : process.env.REACT_APP_OAUTH_O365_CLIENT;
          const authority = item.msType === 'gcc' ? 'https://login.microsoftonline.us/common' : 'https://login.microsoftonline.com/common';
          const state = item.msType === 'gcc' ? 'gcc' : 'normal';
          redirectToService(`${authority}/oauth2/v2.0/authorize?prompt=login&client_id=${clientId}&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=${state}&redirect_uri=${process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL}`);
        } else if(item.calendarAccountType == 'caldav'){
          redirectToService("/dashboard/accounts/new?caldav=" + encodeURIComponent(item.email));
        } else { // google
          redirectToService(`https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_OAUTH_GOOGLE_CLIENT}&login_hint=${item.email}&redirect_uri=${process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_GOOGLE_URL}&response_type=code&prompt=login&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.events+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.readonly&access_type=offline`);
        }
      })
      .catch((error) => {
         alert(error.response?.data?.message || 'An error occurred during re-authentication setup.');
      });
  }

  const handleClick = (key) => { // Receive key directly
    if (key === '0') reauth();
    else if (key === '1') showDeleteConfirm();
  }

  const menuItems = (
    <CBMenu onClick={({ key }) => handleClick(key)}> {/* Pass key directly */}
      <CBMenuItem key="0" icon={
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>}>
        {t('scheduler.selectList.accountItem.reAuth')}
      </CBMenuItem>
      <CBMenuItem key="1" className="text-red-600" icon={<FontAwesomeIcon icon={faTrashAlt} className="mr-2"/>}>
        {t('scheduler.selectList.accountItem.delete')}
      </CBMenuItem>
    </CBMenu>
  );

  return (
    <>
      <div className="rounded-sm border-2 border-neutral_1 mt-2 mb-6 flex flex-col shadow-sm">
        <div className="flex flex-col pl-4 pr-4 pb-4">
          <div>
            <CBHeader
              label={<div className="text-sm lg:text-lg truncate">{item.email}</div>} // Added truncate
              icon={
                item.calendarAccountType == 'google' ? (
                  <GoogleLogo className="w-6 h-6" /> // Added size
                ) : (
                  <FontAwesomeIcon
                    icon={accountIconMap[item.calendarAccountType]?.icon || 'calendar'} // Safe access
                    size="lg" // Adjusted size
                    color={accountIconMap[item.calendarAccountType]?.color || '#888'} // Safe access
                  />
                )
              }
              menu={
                <div className="flex-grow text-right"> {/* Align menu trigger to right */}
                  {!preview && (
                     // Replaced Dropdown with CBDropdown
                    <CBDropdown overlay={menuItems} trigger={['click']} placement="bottomRight">
                       {/* Replaced Button with CBButton */}
                      <CBButton type="ternary" icon={<More />} size="large" />
                    </CBDropdown>
                  )}
                </div>
              }
            />
          </div>
          {item.errorState != '' && item.errorState != 'Personal' && (
             // Replaced Alert with CBAlert
             <CBAlert
              message={t('scheduler.selectList.accountItem.authIssueAlert')}
              variant="error" // Map type
              showIcon // Assuming CBAlert handles icon based on variant
              className="mt-2" // Added margin
            />
          )}
          {item.errorState != '' && item.errorState == 'Personal' && (
            <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/microsoft-plan-and-account-types/" target="_blank" rel="noopener noreferrer">
              {/* Replaced Alert with CBAlert */}
              <CBAlert
                message={t('scheduler.selectList.accountItem.msftPersonalAlert')}
                variant="error" // Map type
                showIcon
                className="mt-2" // Added margin
              />
            </a>
          )}
        </div>
        <div className="bg-neutral_1 p-4 flex flex-col justify-center">
          <CBListItem
            onClick={(e) => setShowCalendars(!showCalendars)}
            border={false}
            icon={
              <div className="rounded-full flex flex-row gap-x-2 items-center justify-center pt-2 pb-2 pl-4 pr-4 bg-white cursor-pointer"> {/* Added cursor */}
                {item.calendars.length}{' '}
                {showCalendars ? ( /* Chevron Down */
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                ) : ( /* Chevron Right */
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                )}
              </div>
            }
          >
            {t('scheduler.selectList.accountItem.calendars')}
          </CBListItem>
          {showCalendars && (
            <CBList className="mt-2 max-h-40 overflow-y-auto"> {/* Added scroll */}
              {item.calendars.map((e) => (
                <CBListItem key={e.id} className="text-sm">{e.name || e.summary}</CBListItem> // Added text-sm
              ))}
            </CBList>
          )}
        </div>
      </div>
      {/* Delete Account Modal */}
       <CBModal
        title={t('scheduler.selectList.accountItem.deleteAccountModalTitle')}
        visible={showDeleteModal}
        onPositiveClick={handleDeleteConfirm}
        onCancelClick={() => setShowDeleteModal(false)}
        positiveLabel={t('scheduler.selectList.accountItem.delete')}
        negativeLabel={t('scheduler.selectList.accountItem.cancel')}
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
      >
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3" />
          <p>{t('scheduler.selectList.accountItem.deleteAccountConfirm')}</p>
        </div>
      </CBModal>
    </>
  )
}
// --- End of AccountItem Component ---


// --- ScheduleSelectList Component ---
const ScheduleSelectList = () => {
  const { t } = useLocalization(); // Initialize localization hook for ScheduleSelectList
  const navigate = useNavigate();
  const [schedules] = useGlobalState('schedules')
  const [loadingCoreData] = useGlobalState('loadingCoreData')
  const [integrations] = useGlobalState('integrations')
  const [license] = useGlobalState('license')
  const [showConfig, setShowConfig] = useState(false)
  const [showError,setShowError] = useState("") // State for showing errors from AccountItem

  function getPlanCount() {
    if (license?.planId?.includes('admin')) return 0;
    if (license?.planId?.includes('pro')) return 10;
    return 10; // Default for basic/premium/trial
  }
  function checkLicense() {
    return license?.v3limit && schedules && schedules.length >= getPlanCount();
  }

  useEffect(() => {
    if (license && license.vanityAlias == '') {
      setShowConfig(true);
    }
  }, [license]);

  // Delete Integration Modal Logic
  const [showDeleteIntegrationModal, setShowDeleteIntegrationModal] = useState(false);
  const [integrationToDelete, setIntegrationToDelete] = useState(null);

  const handleDeleteIntegrationConfirm = async () => {
    if (!integrationToDelete) return;
    setShowDeleteIntegrationModal(false);
    try {
      await API.del('group-bookings', '/integrations', { body: { code: integrationToDelete.accountId } });
      window.location.reload();
    } catch (ex) {
      console.error("Error deleting integration:", ex);
      alert("Failed to remove Zoom account.");
    } finally {
      setIntegrationToDelete(null);
    }
  };

  function showDeleteIntegrationConfirm(integration) {
    setIntegrationToDelete(integration);
    setShowDeleteIntegrationModal(true);
  }


  const renderCreate = () => (
    <div className="mt-8 mb-8">
      <CBButton
        icon={<Add />}
        onClick={(e) => navigate('/dashboard/schedules/new')}
        long={true}
        disabled={checkLicense()}
        type="primary" // Ensure it looks like a primary action
      >
        {t('scheduler.selectList.createSchedulerButton')}
      </CBButton>
       {checkLicense() && <p className="text-sm text-red-600 mt-1">{t('scheduler.selectList.limitReached')}</p>}
    </div>
  )
{console.log(schedules)}
  const list = schedules
    ?.sort((a, b) => (a.label || a.displayName).localeCompare(b.label || b.displayName))
    ?.map((schedule) => (
      <ScheduleItem
        key={schedule.id}
        item={schedule}
        showClone={!checkLicense()}
      />
    )) || []; // Handle schedules being null/undefined initially

  const integrationList = integrations?.map((zoom) => ( // Handle integrations being null/undefined
    <CBListItem
      key={zoom.accountId} // Use accountId as key
      border={false}
      icon={
        <CBButton
          type="text" // Use text type for subtle button
          className="float-right mt-0 p-1 text-gray-500 hover:text-red-600" // Minimal styling
          onClick={() => showDeleteIntegrationConfirm(zoom)} // Show modal
          icon={<Close className="w-4 h-4"/>}
        />
      }
    >
      <div className="flex flex-row items-center">
        <img className="mr-2 rounded-full w-[30px] h-[30px]" src={zoomImage} alt="Zoom Logo"/>
        <span className="text-sm">{zoom.email}</span> {/* Ensure text size consistency */}
      </div>
    </CBListItem>
  )) || []; // Handle integrations being null/undefined

  if(license?.planId?.includes('admin')) {
    return <div className="cb-content-pane mobile_padding min-h-screen text-2xl p-4">{t('scheduler.selectList.adminCannotCreate')}</div>
  }

  return (
    <div className="cb-content-pane mobile_padding min-h-screen">
      <CBHeader
        label={t('scheduler.selectList.headerLabel')} icon={<Scheduling />} buttonLabel={t('scheduler.selectList.headerHelpButton')} buttonIcon={<Info />}
        buttonAction={() => window.open('https://help.calendarbridge.com/doc/getting-started/creating-a-scheduling-link/', '_blank')}
      />
      <div>
        {renderCreate()}
        {showError && <CBAlert variant="error" message={showError} className="mb-4" onClose={() => setShowError("")} />}

        <a className="flex flex-row items-center gap-x-2 mb-2 cursor-pointer text-blue-600 hover:underline text-sm" // Adjusted size
           onClick={() => setShowConfig(!showConfig)}>
          {showConfig ? ( /* Chevron Down */
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          ) : ( /* Chevron Right */
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          )}{' '}
          {showConfig ? t('scheduler.selectList.hideConfig') : t('scheduler.selectList.configureConfig')} {t('scheduler.selectList.configLinkText')}
        </a>
        {showConfig && (
          <div className="rounded-sm border-2 border-neutral_1 mt-2 mb-6 flex flex-col shadow-md p-4"> {/* Added padding */}
            <VanityUrl />
            <CBHeader label={t('scheduler.selectList.videoIntegrationsHeader')} subheader={true} className="mt-4"/> {/* Added margin */}
            {integrationList.length > 0 ? <CBList>{integrationList}</CBList> : <p className="text-sm text-gray-500 p-2">{t('scheduler.selectList.noIntegrations')}</p>}
            <center className="mt-4">
              <a className="mb-4 text-blue-600 hover:underline"
                 href={`https://zoom.us/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_OAUTH_ZOOM_CLIENT}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_OAUTH_REDIRECT_URL + '/dashboard/zoom/')}`}>
                {t('scheduler.selectList.addZoomAccount')}
              </a>
            </center>
          </div>
        )}
      </div>

      {loadingCoreData && (
        <div className="v-full flex items-center justify-center mt-8">
           {/* Replaced Spin with CBSpin */}
           <CBSpin
            spinning={true}
            size="large"
            
          />
        </div>
      )}
      {list}
      {!loadingCoreData && list.length == 0 && (
        <div className="p-4 bg-gray-50 border text-center text-gray-500 rounded">{t('scheduler.selectList.noSchedulers')}</div> // Added rounded
      )}

       {/* Delete Integration Modal */}
       <CBModal
        title={t('scheduler.selectList.removeZoomModalTitle')} visible={showDeleteIntegrationModal}
        onPositiveClick={handleDeleteIntegrationConfirm}
        onCancelClick={() => { setIntegrationToDelete(null); setShowDeleteIntegrationModal(false); }}
        positiveLabel={t('scheduler.selectList.accountItem.delete')} negativeLabel={t('scheduler.selectList.accountItem.cancel')}
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
      >
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3" />
          <p>{t('scheduler.selectList.removeZoomConfirm', { email: integrationToDelete?.email })}</p>
        </div>
      </CBModal>

    </div>
  )
}

export default ScheduleSelectList;
